import React, { Component } from 'react';
import { any } from 'prop-types';
import gql from 'graphql-tag';
import QueryManager from './Query';
import { withReloadable } from '../../hoc';
import { get} from 'lodash';

export const QUERY_GET_ORDER_QR_BY_NUMORDER = gql`
    query getOrderQrById($numOrder: String!) {  
        getOrderQrById(numOrder: $numOrder) {     
            id
            qr
            idOrder
            shopper
            date
            actionDescription
            actionNumber
            updateDate
        }
    }
`;

class OrderQrByNumOrder extends Component {
    static propTypes = {
        children: any
    }

    render() {
        const { children, ...props } = this.props;

        return (
            <QueryManager query={QUERY_GET_ORDER_QR_BY_NUMORDER} variables={{ numOrder: props.numOrder }} {...props}>
                {({ data, loading, fetchMore, refetch, networkStatus }) => {
                    
                    const orderQrData = get(data, 'getOrderQrById', []);
                    return children({
                        data: orderQrData,
                        loading,
                        refetch,
                        fetchMore: ({ pageSize }) => fetchMore({
                            query: QUERY_GET_ORDER_QR_BY_NUMORDER,
                            variables: { numOrder: props.numOrder, size: pageSize },
                            updateQuery: () => (null)
                        }),
                        networkStatus
                    });
                }}
            </QueryManager>
        );
    }
}

export default withReloadable(OrderQrByNumOrder, ['ts']);